import React from 'react';

const DetailPageSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col h-full w-full bg-white dark:bg-gray-900">
      {/* Tab Bar Skeleton */}
      <div className="flex-shrink-0 bg-background-light dark:bg-background-dark border-b border-gray-200 dark:border-gray-700 px-4 py-3">
        <div className="flex gap-4">
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-24 animate-fadePulse"></div>
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-24 animate-fadePulse"></div>
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-24 animate-fadePulse"></div>
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-24 animate-fadePulse"></div>
        </div>
      </div>

      {/* Content Area Skeleton */}
      <div className="flex-1 overflow-y-auto custom-scrollbar px-4 py-6 space-y-6">
        {/* Header Section */}
        <div className="space-y-4">
          <div className="h-8 bg-gray-300 dark:bg-gray-700 rounded w-1/3 animate-fadePulse"></div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Left Column */}
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 space-y-3"
                >
                  <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/2 animate-fadePulse"></div>
                  <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-3/4 animate-fadePulse"></div>
                </div>
              ))}
            </div>

            {/* Right Column */}
            <div className="space-y-4">
              <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-1/3 animate-fadePulse mb-4"></div>
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 flex items-center gap-3"
                >
                  <div className="w-8 h-8 bg-gray-300 dark:bg-gray-700 rounded-full flex-shrink-0 animate-fadePulse"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-2/3 animate-fadePulse"></div>
                    <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-1/2 animate-fadePulse"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Feed/List Section */}
        <div className="space-y-3 mt-8">
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-1/4 animate-fadePulse mb-4"></div>
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 space-y-3"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-6 h-6 bg-gray-300 dark:bg-gray-700 rounded-full flex-shrink-0 animate-fadePulse"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 animate-fadePulse"></div>
                  <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-1/4 animate-fadePulse"></div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full animate-fadePulse"></div>
                <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-5/6 animate-fadePulse"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailPageSkeleton;
